import type { IconData } from '@stacksjs/iconify-core'

export const esCt1x1: IconData = {
  "body": "<path fill=\"#fcdd09\" d=\"M0 0h512v512H0z\"/><path stroke=\"#da121a\" stroke-width=\"60\" d=\"M0 90h810m0 120H0m0 120h810m0 120H0\" transform=\"scale(.6321 .94815)\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default esCt1x1
